/* eslint-disable no-param-reassign,react/no-unused-prop-types */
import { makeStyles } from '@material-ui/core/styles';
import CustomIcon from 'commons/Icon/CustomIcon';
import * as PropTypes from 'prop-types';
import React from 'react';
import { MOBILE_BREAKPOINT } from 'utils/constants/responsive';

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    display: `flex`,
    height: `${props.width}px solid`,
    width: `${props.height}px`,
    minWidth: `${props.height}px`,
    backgroundColor: `${props.backgroundColor}`,
    borderBottomRightRadius: `${props.height}px`,
    borderTopRightRadius: `${props.height}px`,
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      display: props.notOnMobile ? 'none' : 'block'
    }
  })
}));

export const HalfCircle = (props) => {
  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      {
        props.withIcon ? (<CustomIcon className={props.iconStyle} icon={props.icon} size={props.size} />) : null
      }
    </div>
  );
};

HalfCircle.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  icon: PropTypes.object.isRequired,
  iconStyle: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  withIcon: PropTypes.bool
};
  
HalfCircle.defaultProps = {
  withIcon: false
};